import React from 'react';
import { graphql } from 'gatsby';
import { FaCheck, FaLaptop, FaPiggyBank, FaHandsHelping } from 'react-icons/fa';
import { usePageContext } from '../contexts/page-context';
import siteMetadata from '../siteMetadata';

const WhyHireMe = ({ title, highlights = [], className }) => {
  const {
    pageContext: { lang },
  } = usePageContext();

  return (
    <div className={className}>
      <div className="text-4xl mb-8 leading-tight text-center">{title}</div>
      <div className="flex flex-col items-center">
        <ul className="flex flex-col text-2xl font-black w-full lg:flex-row lg:mb-8">
          <li className="flex flex-col items-center justify-center flex-1 mb-12">
            <FaLaptop className="text-light-500 text-6xl mb-2 flex-1" />
            <div>
              <span className="text-3xl font-normal">100</span>
              <span>{lang === siteMetadata.defaultLang ? '% Online and Safe' : '% Remoto y Seguro'}</span>
            </div>
          </li>
          <li className="flex flex-col items-center flex-1 mb-12">
            <FaHandsHelping className="text-light-500 text-6xl mb-2 flex-1" />
            <div>{lang === siteMetadata.defaultLang ? 'Personal Lawyer' : 'Trato Personal'}</div>
          </li>
          <li className="flex flex-col items-center flex-1 mb-12">
            <FaPiggyBank className="text-light-500 text-6xl mb-2 flex-1" />
            <div>{lang === siteMetadata.defaultLang ? 'Affordable' : 'Asequible'}</div>
          </li>
        </ul>
        <ul className="space-y-4 lg:w-2/3">
          {highlights.map(({ highlight }) => (
            <li key={highlight} className="font-serifdisplay flex text-xl">
              <FaCheck className="text-green-600 relative top-1 flex-none" />
              <span className="ml-2 font-normal text-lg">{highlight}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

// const WhyHireMeWithQuery = ({ className }) => (
//   <StaticQuery
//     query={graphql`
//       query WhyHireMeQuery {
//         prismicWhyHireMe {
//           data {
//             title {
//               text
//             }
//             highlights {
//               highlight
//             }
//           }
//         }
//       }
//     `}
//     render={data => <WhyHireMe className={className} data={data} />}
//   />
// );

export const WhyHireMeFragment = graphql`
  fragment WhyHireMeFragment on PrismicWhyHireMe {
    data {
      title {
        text
      }
      highlights {
        highlight
      }
    }
  }
`;

export default WhyHireMe;
